import type { ReactElement } from "react"
import type { PageWithExternalScripts } from "@onestore-graphql/Model"
import { get } from "lodash"
import GenesysChat from "~/components/GenesysChat"
import useGenesysChatQuery from "~/hooks/useGenesysChatQuery"
import log from "~/lib/log"
import ContactLeader from "../ContactLeader"
import ThuliumChat from "../ThuliumChat"

type ExternalScriptsProps = {
  page: PageWithExternalScripts
}

export default function ExternalScripts({
  page,
}: ExternalScriptsProps): ReactElement<ExternalScriptsProps> {
  const genesysChat = useGenesysChatQuery()
  log(page, "ExternalScripts")

  const contactLeader = get<
    PageWithExternalScripts,
    "flatData",
    "contactLeaders",
    number
  >(page, ["flatData", "contactLeaders", 0])

  const thuliumChat = get<
    PageWithExternalScripts,
    "flatData",
    "thuliumChats",
    number
  >(page, ["flatData", "thuliumChats", 0])

  const hasGenesysChat = get<
    PageWithExternalScripts,
    "flatData",
    "hasGenesysChat"
  >(page, ["flatData", "hasGenesysChat"])

  return (
    <>
      {contactLeader && contactLeader.flatData.enabled ? (
        <ContactLeader id={contactLeader.flatData.id} />
      ) : null}

      {thuliumChat && thuliumChat.flatData.enabled ? (
        <ThuliumChat id={thuliumChat.flatData.id} />
      ) : null}

      {hasGenesysChat && genesysChat && genesysChat.enabled ? (
        <GenesysChat
          domainName={genesysChat.domainName}
          environmentName={genesysChat.environmentName}
          deploymentId={genesysChat.deploymentId}
        />
      ) : null}
    </>
  )
}
